import { CheckNotes, InspectionCase, SummaryNotes } from '../inspection-cases';
import { Cases, Inspection } from '../inspection.dto';
import { WaterNetworkCharacterization } from '../water-network-characterization.dto';
import { Standard_1205_part_1 } from './standard-1205-part-1.dto';
import { Standard_1205_part_6 } from './standard-1205-part-6.dto';
import { Standard_1205 } from './standard-1205.dto';

export class InspectionFireTapsDto extends InspectionCase {
  standard_1205?: Standard_1205;
  standard_1205_part_1?: Standard_1205_part_1;
  standard_1205_part_6?: Standard_1205_part_6;
  waterNetworkCharacterization?: WaterNetworkCharacterization;
  summaryNotes?: SummaryNotes[];
}

export class InspectionFireTaps
  extends InspectionFireTapsDto
  implements Inspection
{
  constructor(
    data: InspectionFireTapsDto = {
      title: 'בדיקת התקנת ברזי שריפה',
      isApplicable: true,
      summaryNotes: []
    }
  ) {
    super(data);
    this.summaryNotes = data.summaryNotes;
    this.standard_1205 = new Standard_1205(data.standard_1205);
    this.standard_1205_part_1 = new Standard_1205_part_1(
      data.standard_1205_part_1
    );
    this.standard_1205_part_6 = new Standard_1205_part_6(
      data.standard_1205_part_6
    );
    this.waterNetworkCharacterization = new WaterNetworkCharacterization(
      data.waterNetworkCharacterization
    );
  }

  setInspectionStatus(): void {
    this.standard_1205.setInspectionStatus();
    this.standard_1205_part_1.setInspectionStatus();
    this.standard_1205_part_6.setInspectionStatus();
    this.waterNetworkCharacterization.setInspectionStatus();

    this.isPassed =
      this.standard_1205.isPassed &&
      this.standard_1205_part_1.isPassed &&
      this.standard_1205_part_6.isPassed &&
      this.waterNetworkCharacterization.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.standard_1205.getNotes(),
      ...this.standard_1205_part_1.getNotes(),
      ...this.standard_1205_part_6.getNotes(),
      ...this.waterNetworkCharacterization.getNotes()
    ];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.standard_1205.setAsApplicable();
    this.standard_1205_part_1.setAsApplicable();
    this.standard_1205_part_6.setAsApplicable();
    this.waterNetworkCharacterization.setAsApplicable();
  }

  getCases(): Cases[] {
    return [
      {
        title: this.title,
        cases: [
          this.standard_1205,
          this.standard_1205_part_1,
          this.standard_1205_part_6,
          this.waterNetworkCharacterization
        ]
      }
    ];
  }
}
